import styled from "styled-components";
import { carryType } from "../../types/types";
import { useState } from "react";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: space-between;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
`;

const ItemBox = styled.div<{
  $isSelected?: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32%;
  height: 6.2vw;
  border-radius: 0.6vw;
  font-size: 2.4vw;
  font-weight: 500;
  background-color: ${(props) => (props.$isSelected ? "#FF7F3B" : "#F2F2F2")};
  color: ${(props) => (props.$isSelected ? "white" : "black")};
  border: ${(props) =>
    props.$isSelected ? "1px solid #FF7F3B" : "1px solid #626262"};
`;

export default function CarryTypeSelectionComponent(props: any) {
  const carryTypeList = carryType;
  const { selected, setSelected } = props;

  return (
    <Wrapper>
      {carryTypeList.map((item: any) => {
        return (
          <ItemBox
            key={item.statusCode}
            $isSelected={selected === item.statusCode}
            onClick={() => setSelected(item.statusCode)}
          >
            {item.status}
          </ItemBox>
        );
      })}
    </Wrapper>
  );
}
